const s = "128.0.0", e = "13.10.0";
export {
  s as designSystemVersion,
  e as designTokensVersion
};
